export default __webpack_public_path__ + "static/media/B0007.d175870b.png";